import QueryService from "./QueryService";

export const uploadFileToS3 = async (
	file: File,
	fileCategory: string,
	onProgress?: (pct: number) => void,
	fileName?: string,
): Promise<string> => {
	const queryService = new QueryService("/upload-file");
	const { url, final_url } = await queryService.post(`/presigned_url`, {
		file_name: fileName ?? file.name ?? `file_${Date.now()}`,
		content_type: file.type || "application/octet-stream",
		file_category: fileCategory,
	});

	await new Promise<void>((resolve, reject) => {
		const xhr = new XMLHttpRequest();
		xhr.open("PUT", url);
		xhr.setRequestHeader("Content-Type", file.type || "application/octet-stream");
		xhr.upload.onprogress = (evt) => {
			if (evt.lengthComputable) {
				const pct = Math.round((evt.loaded / evt.total) * 100);
				onProgress?.(pct);
			}
		};
		xhr.onerror = () => reject(new Error("Upload failed"));
		xhr.onload = () => {
			if (xhr.status >= 200 && xhr.status < 300) resolve();
			else reject(new Error(`Upload failed with status ${xhr.status}`));
		};
		xhr.send(file);
	});

	return final_url;
};
